import React from "react";
import clockstopwatch from "../../images/clockstopwatch.svg";
import { calculateDuration } from "utils";
import TooltipWrapper from "components/CandidateProfile/TooltipWrapper";

interface WorkExperience {
  designation: string;
  company_name: string;
  role_start_date: string;
  role_end_date: string;
  role_start_date_formatted: string;
  role_end_date_formatted: string;
}

interface ExperienceListProps {
  work_experience: WorkExperience[];
  tooltips?: any
}

const getExpToolTip = (exp: any) => {
  const item = exp;
  if (item) {
    console.log("Item 76: ", item);
    if (item?.modified_date) {
      const date = new Date(item?.modified_date).toISOString()
        .split("T")[0];
      return `${item.is_edited ? "Edited" : "Added"} by ${item.edited_by} on ${date}`;
    }
    return;
  }
  return;
};

const ExperienceList: React.FC<ExperienceListProps> = ({ work_experience, tooltips }) => {
  const workExperiences = work_experience || [];
  const displayedExperiences = workExperiences.slice(0, 2);
  return (
    <ul className="list-disc pl-5">
      {displayedExperiences.slice(0, 2).map((experience, index) => (
        <li className="text-text-heading mb-2" key={index}>
          <TooltipWrapper text={getExpToolTip(experience)!} placement="right" key={index}>
            <div className="flex items-center gap-1.5 flex-wrap">
              <p className="text-fonttext-primary font-semibold text-sm">{experience.designation}</p>
              at
              <p className="text-text-tertiary font-semibold text-sm">{experience.company_name}</p>
              {experience.role_start_date_formatted &&
                <>
                  <img src={clockstopwatch} alt="clock" />

                  <p className="text-xs">
                    {`${experience.role_start_date_formatted} - ${experience.role_end_date_formatted
                      } (${calculateDuration(experience.role_start_date, experience.role_end_date)})`}
                  </p>
                </>
              }
            </div>
          </TooltipWrapper>
        </li>
      ))}
    </ul>
  );
};

export default ExperienceList;
